import styled, { css } from 'styled-components';

const Label = styled.label`
  position: relative;
  display: flex;
  align-items: center;
  padding-left: 0.625rem;
  font-size: ${({ theme }) => theme.typography.pxToRem(15)};
  font-weight: 500;
  /* XXX: 특정 뷰에서 라벨이 두 줄로 나타나는 문제로 인한 자간 조정 */
  letter-spacing: -0.5px;
  ${({ required, theme }) => required && css`
    font-weight: 700;
    ::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: ${theme.palette.secondary.main};
    }
  `}
  ${({ error, theme }) => error && css`
    color: ${theme.palette.error.main};
    ::before {
      background-color: ${theme.palette.error.main};
    }
  `}
`;

export default Label;
